module.exports = __webpack_public_path__ + "img/system_catch02.d332857d.jpg";